import { orderConfirmationShippingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(orderConfirmationShippingInformationStyles, {
    shippingInformationTitleGridItem: {
        width: 12,
        css: css`
            background: ${COLORS.background.shade};
            border-bottom: 1px solid #3470b2;
            padding: 10px 5px;
            @media print {
                -webkit-print-color-adjust: exact;
            }
        `,
    },
    shippingInformationTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingAddressTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingCarrierTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingServiceTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingPoNumberTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingDateRequestedTitle: {
        variant: "h4",
        as: "h4",
    },
    shippingInformationGridContainer: {
        gap: 10,
        css: css`
            margin-bottom: 1rem;
            & p,
            span {
                font-size: ${TYPOGRAPHY.size.smallest};
            }
            > ${GridOffset}{
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        width: 100% !important;
                        margin:0;
                        `,
                    ],
                    "max",
                )}
            }
        `,
    },
});
